import { ReactElement } from "react"
import logo from '../../assets/loading-cartao-de-todos.webp'
import * as S from './loading-style'

export function Loading (): ReactElement {
  return <S.Container>
    <img src={logo} alt="Cartão de TODOS" />
  </S.Container>
}